import { apiService } from './apiService';

export const fetchStreamData = async (apiUrl) => {
    try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error('Failed to fetch stream data');
        return await response.json();
    } catch (error) {
        console.error('Error fetching stream data:', error);
        throw error;
    }
}; 